<template>
    <div>
        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
            id="loader">
            <b-container fluid style="padding-top: 100px; text-align:left">
                <b-row>
                    <b-col cols="12 headerF">
                        <HeaderConsumer />
                    </b-col>
                    <b-col cols="12 headerM">
                        <HeaderConsumerMobile />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-breadcrumb style="background-color: #e9ecef78;">
                            <b-breadcrumb-item href="#" active>Composite Billing Dashboard</b-breadcrumb-item>
                        </b-breadcrumb>
                    </b-col>
                </b-row>
                <b-row class="d-flex justify-content-center" style="min-height: calc(100vh - 200px);">
                    <b-col cols="12" sm="12" md="12" lg="10">
                        <!-- Alert -->
                        <b-row v-if="alertMsg">
                            <b-col cols="12" sm="11" md="10" lg="10">
                                <b-alert :variant="alertVariant" show dismissible @dismissed="alertMsg = ''">
                                    <span style="font-size: 0.8rem;">{{ alertMsg }}</span>
                                </b-alert>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3 align-items-center">
                            <b-col cols="5" sm="auto" md="auto" lg="auto" style="min-width: 140px;">
                                <span class="label">Name :</span>
                            </b-col>
                            <b-col cols="auto" sm="3" md="3" lg="3">
                                <span>{{ userName }}</span>
                            </b-col>
                        </b-row>

                        <b-tabs content-class="mt-3" v-model="activeTab" nav-class="composite-tabs">
                            <template #tabs-end>
                                <b-nav-item href="#" @click.prevent="openExternalPage">
                                    Apply for New Connection
                                </b-nav-item>
                            </template>
                            <!-- ===================== TAB 1: BILL DOWNLOAD ===================== -->
                            <b-tab title="Bill Download" active>
                                <!-- Row: Month and Year dropdowns -->
                                <b-row class="mb-3 align-items-center">
                                    <b-col cols="5" sm="auto" md="auto" lg="auto" style="min-width: 140px;">
                                        <span class="label">Select Month :</span>
                                    </b-col>
                                    <b-col cols="7" sm="3" md="3" lg="3">
                                        <b-form-select v-model="selectedMonth" :options="monthOptions"
                                            :state="submitted ? selectedMonth !== null : null" size="sm">
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>-- Select Month
                                                    --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submitted ? selectedMonth !== null : null">
                                            Please select a month.
                                        </b-form-invalid-feedback>
                                    </b-col>
                                    <b-col cols="5" sm="auto" class="mt-3 mt-sm-0">
                                        <span class="label">Select Year :</span>
                                    </b-col>
                                    <b-col cols="7" sm="3" md="3" lg="3" class="mt-3 mt-sm-0">
                                        <b-form-select v-model="selectedYear" :options="yearOptions"
                                            :state="submitted ? selectedYear !== null : null" size="sm">
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>-- Select Year
                                                    --</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <b-form-invalid-feedback :state="submitted ? selectedYear !== null : null">
                                            Please select a year.
                                        </b-form-invalid-feedback>
                                    </b-col>
                                </b-row>

                                <!-- Row: Download Button -->
                                <b-row class="mb-3 align-items-center">
                                    <b-col cols="5" sm="auto" md="auto" lg="auto" style="min-width: 140px;">
                                        <span class="label" style="visibility: hidden;">Select Month :</span>
                                    </b-col>
                                    <b-col cols="7" sm="3" md="3" lg="3">
                                        <b-button variant="primary" block :disabled="downloading" @click="downloadPdf">
                                            <b-spinner small v-if="downloading" class="mr-2" />
                                            <b-icon v-else icon="download" class="mr-2" />
                                            <span v-if="downloading">Downloading...</span>
                                            <span v-else>Download PDF</span>
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>

                            <!-- ===================== TAB 2: PAYMENT ===================== -->
                           <b-tab title="Payment">
                                <div>
                                     <b-row class="mb-3 align-items-center">
                                        <b-col cols="5" sm="auto" md="auto" lg="auto" style="min-width: 140px;">
                                            <span class="label">Mobile No :</span>
                                        </b-col>
                                        <b-col cols="7" sm="3" md="3" lg="3">
                                            <b-form-input v-model="payMobileNo" size="sm" maxlength="10"
                                                disabled></b-form-input>
                                        </b-col>
                                        <b-col cols="5" sm="auto" class="mt-3 mt-sm-0">
                                            <span class="label">Email :</span>
                                        </b-col>
                                        <b-col cols="7" sm="3" md="3" lg="3" class="mt-3 mt-sm-0">
                                            <b-form-input v-model="payEmail" size="sm" type="email"
                                                placeholder="Optional"></b-form-input>
                                        </b-col>
                                    </b-row>

                                    <!-- Search -->
                                    <b-row class="mb-2">
                                        <b-col cols="12" sm="6" md="4">
                                            <b-input-group size="sm">
                                                <b-input-group-prepend is-text>
                                                    <b-icon icon="search"></b-icon>
                                                </b-input-group-prepend>
                                                <b-form-input v-model="paymentSearch"
                                                    placeholder="Search by consumer no. or name"></b-form-input>
                                                <b-input-group-append v-if="paymentSearch">
                                                    <b-button variant="outline-secondary" @click="paymentSearch = ''">
                                                        <b-icon icon="x"></b-icon>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>

                                    <!-- Consumers table -->
                                    <b-row>
                                        <b-col cols="12">
                                            <div class="payment-table-scroll">
                                                <b-table-simple small bordered hover>
                                                <b-thead>
                                                    <b-tr>
                                                        <b-th style="width: 50px;">Sl. No.</b-th>
                                                        <b-th style="width: 60px;">Select</b-th>
                                                        <b-th>Consumer No</b-th>
                                                        <b-th>Consumer Name</b-th>
                                                        <b-th style="width: 140px;">Balance (₹)</b-th>
                                                        <b-th style="width: 180px;">Recharge Amount (₹)</b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <payment-consumer-row v-for="(item, idx) in filteredPaymentList"
                                                        :key="item.cons_no" :item="item" :index="idx">
                                                    </payment-consumer-row>
                                                    <b-tr v-if="loadingConsumers">
                                                        <b-td colspan="6" class="text-center text-muted">
                                                            <b-spinner small class="mr-2" /> Loading consumers...
                                                        </b-td>
                                                    </b-tr>
                                                    <b-tr v-else-if="!filteredPaymentList.length">
                                                        <b-td colspan="6" class="text-center text-muted">
                                                            {{ paymentSearch ? 'No matching consumers found.' : 'No consumers found.' }}
                                                        </b-td>
                                                    </b-tr>
                                                </b-tbody>
                                                <b-tfoot v-if="paymentList.length">
                                                    <b-tr>
                                                        <b-td colspan="5" class="text-right">
                                                            <strong>Total Amount</strong>
                                                        </b-td>
                                                        <b-td>
                                                            <strong>₹ {{ totalAmount }}</strong>
                                                        </b-td>
                                                    </b-tr>
                                                </b-tfoot>
                                                </b-table-simple>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row class="mb-3 align-items-center justify-content-center">
                                        <b-col cols="12" sm="4" md="3" lg="3" class="text-center">
                                            <b-button variant="success" block :disabled="paying || totalAmount <= 0"
                                                @click="proceedToPay">
                                                <b-spinner small v-if="paying" class="mr-2" />
                                                <span v-if="paying">Processing...</span>
                                                <span v-else>Pay ₹ {{ totalAmount }}</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-container>
        </b-overlay>
    </div>
</template>

<script>
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import PaymentConsumerRow from '@/components/PaymentConsumerRow.vue'

export default {
    name: 'CompositeBillingDashboard',
    components: {
        'HeaderConsumer': HeaderConsumer,
        'HeaderConsumerMobile': HeaderConsumerMobile,
        'PaymentConsumerRow': PaymentConsumerRow
    },
    data() {
        return {
            show: false,
            userName: '',
            mobileNo: '',
            selectedMonth: null,
            selectedYear: null,
            submitted: false,
            downloading: false,
            alertVariant: 'success',
            alertMsg: '',
            alertTimeout: null,
            startYear: 2026,
            accessToken: '',
            consList: '',
            activeTab: 0,
            paymentList: [],
            payMobileNo: '',
            payEmail: '',
            paying: false,
            loadingConsumers: false,
            paymentDataLoaded: false,
            paymentSearch: '',
        }
    },
    computed: {
        monthOptions() {
            return [
                { value: 'january', text: 'January' },
                { value: 'february', text: 'February' },
                { value: 'march', text: 'March' },
                { value: 'april', text: 'April' },
                { value: 'may', text: 'May' },
                { value: 'june', text: 'June' },
                { value: 'july', text: 'July' },
                { value: 'august', text: 'August' },
                { value: 'september', text: 'September' },
                { value: 'october', text: 'October' },
                { value: 'november', text: 'November' },
                { value: 'december', text: 'December' },
            ]
        },
        yearOptions() {
            const currentYear = new Date().getFullYear()
            const years = []
            for (let y = currentYear; y >= this.startYear; y--) {
                years.push({ value: y, text: y.toString() })
            }
            return years
        },
        totalAmount() {
            return this.paymentList
                .filter(item => item.selected && Number(item.amount) > 0)
                .reduce((sum, item) => sum + Number(item.amount), 0)
        },
        filteredPaymentList() {
            const q = this.paymentSearch.trim().toLowerCase();
            if (!q) return this.paymentList;
            return this.paymentList.filter(item =>
                String(item.cons_no).toLowerCase().includes(q) ||
                String(item.cons_name || '').toLowerCase().includes(q)
            );
        }
    },
    watch: {
        alertMsg(val) {
            if (this.alertTimeout) clearTimeout(this.alertTimeout)
            if (val) {
                this.alertTimeout = setTimeout(() => {
                    this.alertMsg = ''
                }, 10000)
            }
        },
        activeTab(newVal) {
            if (newVal === 1 && !this.paymentDataLoaded) {
                this.paymentDataLoaded = true;
                this.fetchConsumerBalances();
            }
        }
    },
    mounted() {
        if (sessionStorage.getItem("accessToken")) {
            this.mobileNo = sessionStorage.getItem("mobile");
            this.accessToken = sessionStorage.getItem("accessToken");
            this.consList = JSON.parse(sessionStorage.getItem("consList"));
            this.userName = sessionStorage.getItem("userName");
            this.payMobileNo = this.mobileNo || '';
        }
        else {
            this.$router.push({ path: '/' })
        }
    },
    methods: {

        async postJson(url, body) {
            console.log('Authorization sent:', this.accessToken);
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': this.accessToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error('Request failed with status ' + response.status);
            }

            return response.json();
        },

        async fetchConsumerBalances() {
            const defaultTowerId = sessionStorage.getItem('towerId') || '';
            const masterConsNos = Array.isArray(this.consList)
                ? this.consList
                : (this.consList ? [this.consList] : []);

            if (!masterConsNos.length) {
                this.paymentList = [];
                return;
            }

            this.loadingConsumers = true;
            this.show = true;
            this.paymentList = [];

            try {
                const requests = masterConsNos.map(consNo =>
                    this.postJson(
                        this.$urlCommon + '/api/web/auth/composite/recharge/payment',
                        { consNo: consNo, mobileNo: this.mobileNo }
                    )
                );

                const responses = await Promise.all(requests);

                const merged = [];
                const seen = new Set();

                responses.forEach(responseData => {
                    const rows = (responseData && responseData.data) || [];
                    rows.forEach(row => {
                        if (seen.has(row.cons_no)) return;
                        seen.add(row.cons_no);
                        merged.push({
                            cons_no: row.cons_no,
                            cons_name: row.cons_name || '',
                            balance: row.balance,
                            tower_id: defaultTowerId,
                            selected: false,
                            amount: null
                        });
                    });
                });

                this.paymentList = merged;
            } catch (error) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Failed to load consumer list. Please try again.';
                console.error(error);
            } finally {
                this.loadingConsumers = false;
                this.show = false;
            }
        },

        async openExternalPage() {
            const masterConsNos = Array.isArray(this.consList)
                ? this.consList
                : (this.consList ? [this.consList] : []);

            if (!masterConsNos.length) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Unable to determine consumer number.';
                return;
            }

            this.show = true;
            this.alertMsg = '';

            try {
                const payload = {
                    consNo: masterConsNos[0],
                    consName: this.userName,
                    mobileNo: this.mobileNo
                };

                console.log('nsc/initiate request:', payload);

                const data = await this.postJson(
                    this.$urlCommon + '/api/web/auth/composite/nsc/initiate',
                    payload
                );

                console.log('nsc/initiate response:', data);

                if (data.redirectUrl) {
                    window.open(data.redirectUrl, '_blank', 'noopener,noreferrer');
                } else {
                    this.alertVariant = 'danger';
                    this.alertMsg = 'Unable to open the page. Please try again.';
                }
            } catch (error) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Unable to open the page. Please try again.';
                console.error(error);
            } finally {
                this.show = false;
            }
        },

        async downloadPdf() {
            this.submitted = true

            if (!this.selectedMonth || !this.selectedYear) {
                this.alertVariant = 'danger'
                this.alertMsg = 'Please select both month and year.'
                return
            }

            this.downloading = true
            this.alertMsg = ''

            let data = {
                consNo: Array.isArray(this.consList) ? this.consList[0] : this.consList,
                month: this.selectedMonth,
                year: String(this.selectedYear),
                mobileNo: this.mobileNo
            };

            this.show = true;

            try {
                const response = await fetch(this.$urlCommon + '/api/web/auth/composite/bill/download', {
                    method: 'POST',
                    headers: {
                        'Authorization': this.accessToken,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                if (!response.ok) {
                    throw new Error('Request failed with status ' + response.status);
                }

                const blob = await response.blob();
                this.show = false;
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${this.selectedMonth}_${this.selectedYear}_composite_bill.pdf`;
                link.click();
                this.alertVariant = 'success'
                this.alertMsg = `Downloading bill for ${this.selectedMonth}/${this.selectedYear}`
            } catch (err) {
                this.show = false;
                console.error(err)
                this.alertVariant = 'danger'
                this.alertMsg = 'Failed to download PDF. Please try again.'
            } finally {
                this.downloading = false
            }
        },
        async proceedToPay() {
            const selectedItems = this.paymentList.filter(item => item.selected);

            if (!selectedItems.length) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Please select at least one consumer to recharge.';
                return;
            }

            const invalid = selectedItems.some(item => !(Number(item.amount) > 0));
            if (invalid) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Please enter a valid recharge amount for all selected consumers.';
                return;
            }

            const groups = {};
            selectedItems.forEach(item => {
                const key = item.tower_id || 'default';
                if (!groups[key]) groups[key] = [];
                groups[key].push(item);
            });

            const towerIds = Object.keys(groups);
            if (towerIds.length > 1) {
                this.alertVariant = 'danger';
                this.alertMsg = 'Selected consumers belong to different towers. Please pay for consumers from a single tower at a time.';
                return;
            }

            const towerId = towerIds[0];
            const group = groups[towerId];

            const payload = {
                payments: group.map(item => ({
                    cons_no: item.cons_no,
                    amount: Number(item.amount)
                })),
                mobile_no: this.payMobileNo || '',
                email: this.payEmail || '',
                tower_id: towerId,
                cons_name: group.length === 1 ? (group[0].cons_name || '') : ''
            };

            this.paying = true;
            this.alertMsg = '';
            this.show = true;

            try {
                const data = await this.postJson(
                    this.$urlCommon + '/api/v2/compositePayment/pgrequest',
                    payload
                );

                if (data.message === '00') {
                    const reqUrl = data.action;
                    const messageToSend = data.msg;
                    const dataToNewPage = { reqUrl: reqUrl, messageToSend: messageToSend };
                    const queryString = new URLSearchParams(dataToNewPage).toString();
                    window.open(`/website/ConsumerDashboardBBPSpage?${queryString}`, '_blank', 'noopener,noreferrer');
                    window.location.reload();
                } else {
                    this.show = false;
                    this.paying = false;
                    this.alertVariant = 'danger';
                    this.alertMsg = 'Unable to initiate payment. Please try again.';
                }
            } catch (error) {
                this.show = false;
                this.paying = false;
                this.alertVariant = 'danger';
                this.alertMsg = 'Payment failed. Please try again.';
                console.error(error);
            }
        }
    }
}
</script>

<style scoped>
.headerF {
    display: block;
}

.headerM {
    display: none;
}

@media (max-width: 768px) {
    .headerF {
        display: none;
    }

    .headerM {
        display: block;
    }
}

.composite-tabs >>> .nav-link.active {
    font-weight: 600;
}

.payment-table-scroll {
    max-height: 60vh;
    overflow: auto;
    position: relative;
    border: 1px solid #dee2e6;
}

.payment-table-scroll >>> table {
    margin-bottom: 0;
}

/* Sticky header row */
.payment-table-scroll >>> thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: #f8f9fa;
}

/* Sticky total row at the bottom, stays visible while scrolling */
.payment-table-scroll >>> tfoot td {
    position: sticky;
    bottom: 0;
    z-index: 3;
    background-color: #fff;
    border-top: 2px solid #dee2e6;
}

@media (max-width: 768px) {
    .payment-table-scroll {
        max-height: 50vh;
    }
}
</style>